import {AlertIcon} from '@primer/octicons-react'
import {Button} from '@primer/react'
import {ForYouItem} from '../shared/ForYouItem'
import {useMergeabilityData} from './use-mergeability-data'
import {ForYouLeadingIcon} from '../shared/ForYouLeadingIcon'
import {hasUnhandledMergeBlocker} from './merge-blocked-visibility'
import {useScrollToMergeBox} from '../../mergebox/use-scroll-to-mergebox'

// Catch-all "Needs attention" item shown to the author when the merge is blocked
// for a reason not covered by a more specific action item (e.g. a failing
// ruleset rule, an unmet merge condition, or an authorization policy).
export function MergeBlocked() {
  const data = useMergeabilityData()
  const scrollToMergeBox = useScrollToMergeBox()

  if (!data) {
    return null
  }

  const {blockedSection, mergeBoxPullRequest} = data
  const {sectionStatus, failingConditionsAndRules} = blockedSection

  if (
    mergeBoxPullRequest.isDraft ||
    sectionStatus === 'PASSED' ||
    !hasUnhandledMergeBlocker(failingConditionsAndRules)
  ) {
    return null
  }

  return (
    <ForYouItem
      leadingVisual={<ForYouLeadingIcon icon={AlertIcon} variant="danger" />}
      title="Merge is blocked"
      itemName="merge-blocked"
      description={undefined}
      actionSlot={
        <Button type="button" size="small" onClick={scrollToMergeBox}>
          View merge status
        </Button>
      }
    />
  )
}
